import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Color Palette";

const callColorPalette = async (
	messageId: string,
	jwt: string,
	tool_document_id: string,
	colors: string,
	batch_size: number,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		processImage: async ({ imageBase64, executionContext }) => {
			const data = {
				prompt_document_id: "o6o7j08cu59w77a3xai5vrfe",
				prompt_index: 0,
				prompt_variables: { colors },
				input_images: [imageBase64],
				jwt,
				tool_document_id,
				batch_size,
			};
			return fetchColorPalette(data, executionContext, messageId);
		},
	});
	return success;
};

export async function fetchColorPalette(
	params: {
		prompt_document_id: string;
		prompt_index: number;
		prompt_variables: { colors: string };
		input_images: string[];
	},
	executionContext: any,
	messageId: string,
): Promise<string | string[] | false> {
	return fetchInferenceJob({
		params,
		executionContext,
		messageId,
		apiPath: "/infer/oplux",
		statusEndpoint: (apiUrl, jobId) =>
			`${apiUrl.replace("/infer/oplux", "")}/status/${jobId}`,
		resultEndpoint: (apiUrl, jobId) =>
			`${apiUrl.replace("/infer/oplux", "")}/result/${jobId}`,
		cancelEndpoint: (apiUrl, jobId) => ({
			url: `${apiUrl.replace("/infer/oplux", "")}/cancel/${jobId}`,
			method: "POST",
		}),
		extractResult: (data) => data.image_base64_list ?? [data.image_base64],
		useGatewayUrl: true,
	});
}

export function useListenColorPaletteMessage() {
	useListenFromRenderer([
		{
			key: "colorPalette",
			onMessage: async (message) => {
				const success = await callColorPalette(
					message.id,
					message.values.jwt,
					message.values.tool_document_id,
					message.values.colors,
					message.values.batch_size,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
